<!--
 * @Descripttion:
 * @Author: zenghua.wang
 * @Date: 2021-09-02 14:43:35
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-10-25 15:59:30
-->
<template>
  <div>
    <el-button
      size="small"
      type="primary"
      icon="el-icon-plus"
      @click="addDic"
    >新增字典</el-button>
    <el-table
      size="small"
      style="width: 100%; margin-top: 20px"
      :data="dicData"
      border
    >
      <el-table-column label="选项名">
        <template slot-scope="scope">
          <el-input
            size="small"
            v-model="scope.row.label"
            placeholder="请输入选项名"
            @change="updateDic"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="选项值">
        <template slot-scope="scope">
          <el-input
            size="small"
            v-model="scope.row.value"
            placeholder="请输入选项值"
            @change="updateDic"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column
        label="禁用"
        align="center"
      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.disabled"
            active-color="#3b9cd9"
            inactive-color="#999"
            @change="updateDic"
          />
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="deleteDic(scope.$index)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { createId } from '@/dragComponents/utils'

export default {
  name: 'dictory-select',
  components: {},
  props: ['dicData', 'change'],
  data() {
    return {}
  },
  methods: {
    // 新增下拉字典
    addDic() {
      this.dicData = (this.dicData || []).filter((item) => {
        return item.label || item.value
      })
      this.dicData.push({
        id: createId(),
        label: '',
        value: '',
        disabled: false
      })
    },
    // 删除下拉字典
    deleteDic(index) {
      this.dicData.splice(index, 1)
    },
    // 更新下拉字典
    updateDic() {
      this.$emit('change', this.dicData)
    }
  }
}
</script>
